<template>
  <b-overlay
    :show="$store.state.overlays.footer"
    variant="dark"
    opacity="0.5"
    blur=""
    no-fade
    wrap-tag="footer"
    class="app-footer"
    z-index="0"
  >
    <template #overlay><span> </span></template>
    <img class="logo"
         :alt="$t('Atlas logo')"
         src="../assets/images/atlas_logo.svg">
    <span>&copy;&nbsp;{{ new Date().getFullYear() }}&nbsp;</span>
    <a href="https://www.fariaedu.com/"
       rel="noopener noreferrer"
       target="_blank">Faria Education Group Ltd.</a>
    <span>&nbsp;All rights reserved.&nbsp;</span>
    <a href="https://www.rubiconatlas.org/privacy/"
       rel="noopener noreferrer"
       target="_blank">Privacy Policy</a>
  </b-overlay>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>

<style scoped lang="scss">
.app-footer {
  background: $white 0 0 no-repeat padding-box;
  box-shadow: 0px -1px 0px $text-color-gray-disabled;
  padding: .5rem;
  display: flex;
  align-items: center;
  min-height: 1.75rem;
  font: normal normal normal .625rem/1rem $font-lato;

  .logo {
    margin-bottom: .125rem;
    margin-right: .25rem;
    width: .75rem;
    height: auto;
  }

  a {
    white-space: nowrap;
  }
}

@media (max-width: 576px) {
  .app-footer {
    justify-content: center;
  }
}

@media print {
  .app-footer {
    display: none !important;
  }
}
</style>
